<template>
  <button class="ui-btn-contribute" @click="handleJumpPage('contribute')">
    <span>我要投稿</span>
  </button>
</template>

<script>
import jumpPage from "@/mixins/jumpPage"

export default {
  name: "btnContribute",
  mixins: [jumpPage]
}
</script>

<style lang="scss" scoped>
.ui-btn-contribute {
  display: inline-flex;
  padding: 0 0.74rem;
  background: #f64e45;
  border-radius: 0.44rem;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  font-family: PingFangSC-Regular;
  font-size: 0.28rem;
  color: #ffffff;
  letter-spacing: 0;
  height: 0.88rem;
  &:active {
    opacity: 0.7;
  }
  &::before {
    content: "";
    display: block;
    width: 0.4rem;
    height: 0.4rem;
    margin-right: 0.14rem;
    background: url("../../../../assets/images/icon_contribute.png") no-repeat center;
    background-size: 100%;
  }
}
</style>
